<app-base-modal
  [title]="qualityControlApprovalsResourceType.name"
  [showStateToggle]="isValid()"
>
  <div class="quality-control-approvals-wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (data of qualityControlApprovalsData(); track $index) {
        <mat-expansion-panel [expanded]="data.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <app-quality-control-approvals-title
                [data]="data"
                [approvalStatusSelectData]="approvalStatusSelectData()"
                [isEditModeActive]="isEditModeActive"
                (handleDelete)="handleDelete($event, data.id, $index)"
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-quality-control-approvals-form
            [productCardQualityControlId]="productCardQualityControlId()"
            [qualityControlApprovalData]="data"
            [qualityControlApprovalsFormGroup]="qualityControlApprovalsFormGroups()[$index]"
            [noFirstData]="noFirstData()"
            [approvalStatusSelectData]="approvalStatusSelectData()"
            [isEditModeActive]="isEditModeActive"
            (updateData)="updateData($event, $index)"
            (deleteData)="deleteData($index)"
            (setLoadingState)="setLoadingState($event)"
          />
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить новое
    </button>
  </div>
</app-base-modal>
